<template>
  <b-container>
    <Headline title="Watchlist" />

    <div class="col-12 col-lg-9">
    <b-row v-if="upcoming">
      <b-col class="upcoming">
        Your next live streaming event starts <em>{{ startsIn(upcoming) }}</em>
        <BigEventCard :event="upcoming" />
      </b-col>
    </b-row>
    </div>

    <b-row class="future-headline" v-if="future.length">
      <b-col>
          <h5>Other events on your watchlist</h5>
      </b-col>
    </b-row>

    <div class="future">
      <EventCard v-for="live in future" :key="live.id"
                 :live="live"
                 :withWatchlistButton="true"></EventCard>
    </div>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    margin-top: 1em;
  }

  .headline {
    border-bottom: 1px solid $warm-grey;
    margin-bottom: 1em;
  }

  .upcoming {
    padding-left: 0px;
    padding-right: 0px;
    em {
      font-weight: bold;
      color: $em-pink;
      font-style: normal;
    }
    @include media-breakpoint-up(lg) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .future-headline {
    margin-top: 1em;
  }

  .future {
    display: flex;
    flex-wrap: wrap;
    justify-items: center;
    justify-content: start;
    margin-left: -10px;
    margin-right: -10px;
    @include media-breakpoint-up(lg) {
      margin-left: 0;
      margin-right: 0;
    }
  }

</style>

<script>
import moment from '@/utils/moment'
import filter from 'lodash/filter'

import BigEventCard from '@/components/widgets/BigEventCard'
import EventCard from '@/components/widgets/EventCard'
import Headline from '@/components/widgets/Headline'

export default {
  name: 'Watchlist',
  components: {
    BigEventCard,
    EventCard,
    Headline
  },
  data () {
    return {
    }
  },
  created () {
    this.initPage()
  },
  computed: {
    watchlist () {
      return filter(this.$store.getters['profile/currentUser'].watchlist, e => moment(e.start).isAfter())
    },
    upcoming () {
      if (!this.watchlist.length) return null
      return this.watchlist[0]
    },
    future () {
      if (this.watchlist.length < 2) return []
      return this.watchlist.slice(1)
    }
  },
  methods: {
    async initPage () {
      // make sure we have the latest watchlist
      await this.$store.dispatch('profile/getCurrentUser')
    },
    startsIn (event) {
      return moment(event.start).fromNow()
    },
    when (event) {
      return moment(event.start).format('MMM Do | h:mm a')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/fan/Watchlist.vue